const trigger = document.getElementById('web-share');
const menu = document.getElementById('share-menu');
const buttons = menu ? Array.from(menu.querySelectorAll('.share-menu__button')) : [];
const ACTIVE_CLASS = 'is-visible';
const COPIED_CLASS = 'share-menu__button--copied';
let outsideClickListener;
let escapeListener;

if (trigger && menu) {
    trigger.addEventListener('click', async (event) => {
        event.preventDefault();

/*         if (navigator.share && !menu.classList.contains(ACTIVE_CLASS)) {
            try {
                await navigator.share({
                    title: document.title,
                    url: window.location.href
                });
                return;
            } catch (error) {
                // Ignore AbortError to allow fallback overlay
                if (error.name !== 'AbortError') {
                    console.warn('Web Share API non disponibile:', error);
                }
            }
        } */

        toggleMenu();
    });

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const target = button.dataset.shareTarget;
            handleShare(target, button);
        });
    });
}

function toggleMenu() {
    if (menu.classList.contains(ACTIVE_CLASS)) {
        closeMenu();
    } else {
        openMenu();
    }
}

function openMenu() {
    menu.classList.add(ACTIVE_CLASS);
    menu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    const firstButton = buttons[0];
    if (firstButton) {
        firstButton.focus({ preventScroll: true });
    }

    outsideClickListener = (event) => {
        if (!menu.contains(event.target) && !trigger.contains(event.target)) {
            closeMenu();
        }
    };

    escapeListener = (event) => {
        if (event.key === 'Escape') {
            closeMenu();
        }
    };

    document.addEventListener('click', outsideClickListener);
    document.addEventListener('keydown', escapeListener);
}

function closeMenu() {
    menu.classList.remove(ACTIVE_CLASS);
    menu.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({ preventScroll: true });

    if (outsideClickListener) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener = undefined;
    }

    if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
        escapeListener = undefined;
    }
}

function handleShare(target, button) {
    const url = window.location.href;
    const title = document.title;
    const text = `${title} - ${url}`;

    switch (target) {
        case 'linkedin':
            openPopup(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`);
            break;
        case 'facebook':
            openPopup(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
            break;
        case 'x':
            openPopup(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`);
            break;
        case 'email':
            window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`;
            break;
        case 'copy':
            copyToClipboard(url, button);
            break;
        default:
            console.warn(`Tipo di condivisione non gestito: ${target}`);
    }

    if (target !== 'copy') {
        closeMenu();
    }
}

function openPopup(shareUrl) {
    const width = 560;
    const height = 636;
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);

    window.open(
        shareUrl,
        'shareWindow',
        `width=${width},height=${height},top=${top},left=${left},noopener`
    );
}

async function copyToClipboard(url, button) {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            showCopiedState(button);
            return;
        }
    } catch (error) {
        console.warn('Impossibile utilizzare la Clipboard API:', error);
    }

    const textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
        const successful = document.execCommand('copy');
        if (successful) {
            showCopiedState(button);
        } else {
            console.warn('La copia negli appunti non è riuscita.');
        }
    } finally {
        document.body.removeChild(textarea);
    }
}

function showCopiedState(button) {
    button.classList.add(COPIED_CLASS);
    const originalLabel = button.getAttribute('aria-label');
    button.setAttribute('aria-label', `${originalLabel}. Copiato!`);

    setTimeout(() => {
        button.classList.remove(COPIED_CLASS);
        if (originalLabel) {
            button.setAttribute('aria-label', originalLabel);
        }
        closeMenu();
    }, 1800);
}
